module.exports = __webpack_public_path__ + "static/media/nima_play_jhali_talking.2d5994a2.gif";